export default function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
// module id = 2831
// module chunks = 30 31 33